import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-manchestore-banner';

const items = [
  {
    text: 'Shaping',
    image: 'https://cdn.skyfastimg.com/images/2026/08/26/image-6a8e6df3dfca91d4091b80bc.webp?w=1000',
  },
  {
    text: 'Smoothing',
    image: 'https://cdn.skyfastimg.com/images/2026/08/26/image-6a8e6e0c704eccb681b60096.webp?w=1000',
  },
  {
    text: 'Polishing',
    image: 'https://cdn.skyfastimg.com/images/2026/08/26/image-6a8e6e0f9ef2e2d2528f7d7e.webp?w=1000',
  },
  {
    text: 'Cuticle Care',
    image: 'https://cdn.skyfastimg.com/images/2026/08/26/image-6a8e6e28a86de5e901ce7e77.webp?w=1000',
  },
];

const renderItem = item => `
  <div class="manchestore-banner__item" data-attribute="manchestore-banner__item">
    <img
      class="manchestore-banner__item-image"
      data-attribute="manchestore-banner__item-image"
      src="${item.image}"
      alt="${item.text}"
      loading="lazy"
    />
    <span class="manchestore-banner__item-text" data-attribute="manchestore-banner__item-text">
      ${item.text}
    </span>
  </div>
`;

const contentHtml = `
  <div class="manchestore-banner container" data-attribute="manchestore-banner">
    <header class="manchestore-banner__header" data-attribute="manchestore-banner__header">
      <div class="manchestore-banner__title" data-attribute="manchestore-banner__title">
        <h2><span style="font-size:40px;"><strong>All-In-One Full Nail Care Kit</strong></span></h2>
      </div>
      <div class="manchestore-banner__heading-support">
        <span
          class="manchestore-banner__divider"
          data-attribute="manchestore-banner__divider"
          data-color="#FE9790"
          style="background-color: #FE9790"
        ></span>
        <div class="manchestore-banner__description" data-attribute="manchestore-banner__description">
          <p><span style="color:hsl( 0, 0%, 15% );">Complete salon-grade care —</span><br><span style="color:hsl( 0, 0%, 15% );">total control in your hand.</span></p>
        </div>
      </div>
    </header>

    <div class="manchestore-banner__content" data-attribute="manchestore-banner__content">
      <div class="manchestore-banner__card" data-attribute="manchestore-banner__card">
        <h3 class="manchestore-banner__card-title" data-attribute="manchestore-banner__card-title">
          4 Heads, 4 Finishes
        </h3>
        <div class="manchestore-banner__items" data-attribute="manchestore-banner__items">
          ${items.map(renderItem).join('')}
        </div>
      </div>

      <div class="manchestore-banner__video" data-attribute="manchestore-banner__video">
        <video autoplay muted loop playsinline aria-label="Manchestore nail care demonstration">
          <source
            data-attribute="manchestore-banner__video-source"
            src="https://cdn.shopify.com/videos/c/o/v/aa8ed108e1d140109dffeef26851ea4d.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#F4EFEC',
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/08/26/image-6a8e6da65e6ffe8de10b5bcc.webp?w=1000',
  useBackgroundMobile: true,
  backgroundImageMobile: 'https://cdn.skyfastimg.com/images/2026/08/26/image-6a8e6daa91d8cc90c0c7c4e9.webp?w=1000',
  textColor: '#292929',
  topPadding: false,
  bottomPadding: false,
});
